import { render } from "./MontagesEdit.vue?vue&type=template&id=3aaa1b65&scoped=true"
import script from "./MontagesEdit.vue?vue&type=script&lang=js"
export * from "./MontagesEdit.vue?vue&type=script&lang=js"

import "./MontagesEdit.vue?vue&type=style&index=0&id=3aaa1b65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaa1b65"]])

export default __exports__